import React, { Children } from 'react';
import { Shield, Lock, Users, Database, Globe, Clock, AlertTriangle, Phone, Mail } from 'lucide-react';
const PrivacyPolicy = () => {
  return <div className="w-full" data-id="element-536">
      {/* Hero Section */}
      <section className="bg-[#0a2e4a] text-white py-16" data-id="element-537">
        <div className="container mx-auto px-4" data-id="element-538">
          <div className="max-w-3xl mx-auto text-center" data-id="element-539">
            <h1 className="text-4xl font-bold mb-6" data-id="element-540">Privacy & Cookie Policy</h1>
            <p className="text-xl" data-id="element-541">How we protect and use your information</p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-542">
        <div className="container mx-auto px-4" data-id="element-543">
          <div className="max-w-3xl mx-auto" data-id="element-544">
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-545">
              <div className="flex items-center mb-6" data-id="element-546">
                <Shield className="text-[#0a2e4a] mr-4 flex-shrink-0" size={28} data-id="element-547" />
                <h2 className="text-2xl font-bold text-[#0a2e4a]" data-id="element-548">
                  Privacy and Cookie Policy - Peakwave
                </h2>
              </div>
              <p className="text-gray-600 mb-6" data-id="element-549">
                At Peakwave, protecting your privacy is a priority. This policy
                explains what information we collect, how we use it, and how we
                keep it secure, ensuring you have confidence in our handling of
                your personal data.
              </p>
            </div>
            <div className="space-y-8" data-id="element-550">
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-551">
                <div className="flex items-center mb-4" data-id="element-552">
                  <Users className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-553" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-554">
                    1. Who We Are
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-555">
                  Peakwave is a UK-based appliance repair and service company
                  specializing in essential household systems.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-556">
                <div className="flex items-center mb-4" data-id="element-557">
                  <Database className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-558" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-559">
                    2. What Information We Collect
                  </h3>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-560">
                  We may collect the following information from you to provide
                  our services and manage your account effectively:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4" data-id="element-561">
                  <li data-id="element-562">
                    Your name and contact details: Including your address, email
                    (sunitalimbu9596@gmail.com), and phone number (0800 055
                    4969).
                  </li>
                  <li data-id="element-563">
                    Payment information: Processed securely through our trusted
                    payment providers.
                  </li>
                  <li data-id="element-564">
                    Records of your service plans and repair history: To ensure
                    continuity of service and support.
                  </li>
                </ul>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-565">
                <div className="flex items-center mb-4" data-id="element-566">
                  <Users className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-567" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-568">
                    3. How We Use Your Information
                  </h3>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-569">
                  We use your data primarily to:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-570">
                  <li data-id="element-571">
                    Manage and administer your service plans: Including
                    activation, renewals, and plan adjustments.
                  </li>
                  <li data-id="element-572">
                    Arrange repairs and provide customer support: Dispatching
                    engineers for your appliances, and addressing your queries.
                  </li>
                  <li data-id="element-573">
                    Send important updates and information: Related to your
                    service, appointments, and policy changes.
                  </li>
                  <li data-id="element-574">
                    Comply with legal and regulatory obligations: Ensuring we
                    operate within the law.
                  </li>
                </ul>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-575">
                <div className="flex items-center mb-4" data-id="element-576">
                  <Users className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-577" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-578">
                    4. Third-Party Providers
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-579">
                  We work with trusted third parties, such as payment processors
                  and website hosting providers, to deliver our services
                  efficiently and securely. We want to assure you that we do not
                  sell your personal information to any third parties.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-580">
                <div className="flex items-center mb-4" data-id="element-581">
                  <Database className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-582" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-583">
                    5. Cookies
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-584">
                  Our website uses cookies to enhance your browse experience and
                  improve site performance. Cookies are small data files stored
                  on your device that help us understand how you interact with
                  our site. You can manage or disable cookies through your
                  browser settings at any time, but please note this may affect
                  certain website functionalities.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-585">
                <div className="flex items-center mb-4" data-id="element-586">
                  <Users className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-587" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-588">
                    6. Your Rights
                  </h3>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-589">
                  Under applicable data protection laws, you have specific
                  rights regarding your personal data. You have the right to:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4" data-id="element-590">
                  <li data-id="element-591">
                    Request access to the personal data we hold about you.
                  </li>
                  <li data-id="element-592">Ask for corrections or deletion of your data.</li>
                  <li data-id="element-593">
                    Withdraw your consent to marketing communications at any
                    time.
                  </li>
                </ul>
                <p className="text-gray-600 mb-4" data-id="element-594">
                  To exercise these rights, please contact us at:
                </p>
                <div className="space-y-2 mb-4" data-id="element-595">
                  <div className="flex items-center" data-id="element-596">
                    <Mail className="text-[#0a2e4a] mr-2 flex-shrink-0" size={16} data-id="element-597" />
                    <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] hover:underline" data-id="element-598">
                      sunitalimbu9596@gmail.com
                    </a>
                  </div>
                  <div className="flex items-center" data-id="element-599">
                    <Phone className="text-[#0a2e4a] mr-2 flex-shrink-0" size={16} data-id="element-600" />
                    <a href="tel:08000554969" className="text-[#0a2e4a] hover:underline" data-id="element-601">
                      0800 055 4969
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-602">
                <div className="flex items-center mb-4" data-id="element-603">
                  <Users className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-604" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-605">
                    7. Sharing Your Data
                  </h3>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-606">
                  We may share your information with:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-607">
                  <li data-id="element-608">
                    Service providers essential to our operations: Such as
                    payment processors, IT support, and website hosting
                    services, who act on our behalf.
                  </li>
                  <li data-id="element-609">
                    Law enforcement or regulatory authorities: When required by
                    law or in response to a valid legal request.
                  </li>
                  <li data-id="element-610">
                    Marketing partners: But only with your explicit consent,
                    which you can withdraw at any time.
                  </li>
                </ul>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-611">
                <div className="flex items-center mb-4" data-id="element-612">
                  <Clock className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-613" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-614">
                    8. Data Retention
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-615">
                  We retain your personal data only as long as necessary to:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-616">
                  <li data-id="element-617">Provide and manage our services to you effectively.</li>
                  <li data-id="element-618">Comply with legal and regulatory requirements.</li>
                  <li data-id="element-619">Resolve disputes or complaints.</li>
                </ul>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-620">
                <div className="flex items-center mb-4" data-id="element-621">
                  <Users className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-622" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-623">
                    9. Children's Privacy
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-624">
                  Our services are not intended for individuals under 16 years
                  old. We do not knowingly collect personal data from minors. If
                  we become aware that such data has been collected, we will
                  take steps to delete it.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-625">
                <div className="flex items-center mb-4" data-id="element-626">
                  <Lock className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-627" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-628">
                    10. Data Security
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-629">
                  We implement strong security measures, including technical and
                  organizational safeguards, to protect your information from
                  unauthorized access, accidental loss, destruction, or
                  alteration. While we strive for robust security, please
                  understand that no system can guarantee 100% security during
                  data transmission over the internet.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-630">
                <div className="flex items-center mb-4" data-id="element-631">
                  <Globe className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-632" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-633">
                    11. International Data Transfers
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-634">
                  Your data may be stored or processed outside the UK or
                  European Economic Area by our service providers. Where this
                  happens, we ensure appropriate safeguards are in place to
                  protect your data in accordance with relevant data protection
                  laws.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-635">
                <div className="flex items-center mb-4" data-id="element-636">
                  <AlertTriangle className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-637" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-638">
                    12. Updates to This Policy
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-639">
                  We may update this privacy policy occasionally to reflect
                  changes in our practices, technology, or legal requirements.
                  Any changes will be published here with the updated date. We
                  encourage you to review this policy regularly to stay
                  informed.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-640">
                <div className="flex items-center mb-4" data-id="element-641">
                  <Phone className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-642" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-643">
                    13. Contact Us
                  </h3>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-644">
                  If you have any questions or concerns about your data or this
                  policy, please do not hesitate to contact us:
                </p>
                <div className="space-y-2" data-id="element-645">
                  <div className="flex items-center" data-id="element-646">
                    <Mail className="text-[#0a2e4a] mr-2 flex-shrink-0" size={16} data-id="element-647" />
                    <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] hover:underline" data-id="element-648">
                      sunitalimbu9596@gmail.com
                    </a>
                  </div>
                  <div className="flex items-center" data-id="element-649">
                    <Phone className="text-[#0a2e4a] mr-2 flex-shrink-0" size={16} data-id="element-650" />
                    <a href="tel:08000554969" className="text-[#0a2e4a] hover:underline" data-id="element-651">
                      0800 055 4969
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default PrivacyPolicy;